import { Voter } from "@activecollab/security";
import { isPowerClient } from "~/utils/userHelper";

export class SubtaskVoter extends Voter {
  attributes = ["edit"];

  supports(attribute, subject) {
    if (!this.attributes.includes(attribute)) {
      return false;
    }
    return subject && subject.class === "Subtask";
  }

  voteOnAttribute(attribute, subject, user) {
    switch (attribute) {
      case "edit": {
        if (user.class === "Client") {
          return isPowerClient(user);
        }
        return true;
      }
    }

    throw new Error("This code should not be reached!");
  }
}
